import React, { Component } from "react";
import ArrowButton from "../../../common/button-arrow";
import { validators } from "../../../../utils/validators";
import {
  Checkbox,
  Col,
  FormControl,
  Row,
  FormGroup,
  ControlLabel,
  Radio,
} from "react-bootstrap";
import { Errors, Form, Control } from "react-redux-form";
import RequiredInput from "../../../common/form/elements/required-input";
import { connect } from "react-redux";

class GroupForm extends Component {
  render() {
    const { formValid, model, onSubmit } = this.props;

    return (
      <div className="mg-bottom-60 mg-top-10">
        <div className="container-fluid">
          <Form model={model} onSubmit={onSubmit}>
            <Row>
              <Col md={12}>
                <Errors className="errors" model={model} />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <RequiredInput
                  label="HO Account Number"
                  placeholder="HO Account Number"
                  model=".ho_account_number"
                  controlId="ho-account-number"
                />
              </Col>
            </Row>
            <FormGroup controlId="hoAccountActive">
              <div>
                <ControlLabel>Active</ControlLabel>
              </div>
              <Control.radio
                model=".active"
                value="true"
                validators={{
                  required: validators.required(this.updateErrors, "active"),
                }}
                component={Radio}
              >
                Yes
              </Control.radio>
              <Control.radio
                model=".active"
                value="false"
                validators={{
                  required: validators.required(this.updateErrors, "active"),
                }}
                component={Radio}
              >
                No
              </Control.radio>

              <Errors
                show={{ touched: true }}
                className="errors"
                model=".active"
                messages={{ required: "You must set an active state." }}
              />
            </FormGroup>
            <Row>
              <Col md={2} mdOffset={10}>
                <ArrowButton
                  className="pull-right"
                  arrow={false}
                  disabled={!formValid}
                >
                  Save
                </ArrowButton>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  formValid: state.deep.forms.admin_ho_account_save.$form.valid,
});

export default connect(mapStateToProps)(GroupForm);



// WEBPACK FOOTER //
// ./src/components/admin/ho-accounts/form/ho-account-form.jsx